import { computed } from 'vue'

const URLS = {
    images: {
        defaultUserImage: '/images/global/default.png',
        defaultEventImage: '/images/default-artist-event.png'
    }
}

export const useArtistEvent = (event) => {
    const artistEventLabel = computed(() => {
        if (event.value.event_artist_status === null) {
            return 'New!'
        } else if (event.value.counter_offer_status === 7 || event.value.counter_offer_status === 8) {
            return 'Review changes!'
        } else if (event.value.event_artist_status === 3 && event.value.event_status < 4) {
            return "You're booked!"
        } else {
            return ''
        }
    })
    const artistEventVibes = computed(() => event.value.vibe?.split(','))
    const artistEventImage = computed(() =>
        event.value.event_picture ? event.value.event_picture : URLS.images.defaultEventImage
    )
    const artistEventDate = computed(() => event.value.event_full_date)
    const artistPayout = computed(() => {
        switch (event.value.event_status) {
            case 0:
            case 1: {
                if (event.value.event_artist_status === null) {
                    return {
                        label: 'Est. Payout',
                        value: `${_artistPayoutValue.value}`
                    }
                } else if (event.value.event_artist_status === 0) {
                    return {
                        label: 'You offered',
                        value: `${_artistPayoutValue.value.replace("Up to ", "")}`
                    }
                } else if (event.value.event_artist_status === 3) {
                    return {
                        label: 'Payout',
                        value: `${_artistPayoutValue.value}`
                    }
                } else {
                    return {
                        label: 'Payout',
                        value: 'N/A'
                    }
                }
            }
            case 2:
            case 3:
            case 4:
            case 5:
                return {
                    label: 'Payout',
                    value: `${_artistPayoutValue.value}`
                }
        }
    })
    const _artistPayoutValue = computed(() => {
        if (!event.value.event_artist_status) {
            return !event.value.budget || event.value.budget === '0.00'
                ? 'N/A'
                : `Up to $${parseFloat(event.value.budget).toFixed(0)}`
        } else if (event.value.event_artist_status === 3) {
            return `$${parseFloat(event.value.budget - event.value.budget * event.value.artist_fee).toFixed(0)}`
        } else {
            return !event.value.budget || event.value.budget === '0.00'
                ? 'N/A'
                : `$${parseFloat(event.value.budget).toFixed(0)}`
        }
    })
    const artistCta = computed(() => {
        switch (event.value.event_status) {
            case 0:
            case 1: {
                if (event.value.event_artist_status === null) {
                    return {
                        text: 'Make an Offer',
                        display: null
                    }
                } else if (event.value.event_artist_status === 3) {
                    return {
                        text: 'See Details',
                        display: null
                    }
                } else {
                    return {
                        text: 'Edit Offer',
                        display: null
                    }
                }
            }
            case 2: {
                if (event.value.event_artist_status === 3) {
                    return {
                        text: 'Promote Event',
                        display: null
                    }
                } else if (event.value.event_artist_status === null) {
                    return {
                        text: 'Make an Offer',
                        display: null
                    }
                } else {
                    return {
                        text: 'Edit Offer',
                        display: null
                    }
                }
            }
            case 3:
                return {
                    text: 'Review Booker',
                    display: null
                }
            case 4:
            case 5:
            case 6:
                return {
                    text: null,
                    display: 'none',
                    redirect: () => {}
                }
        }
    })

    return {
        artistEventLabel,
        artistEventVibes,
        artistEventImage,
        artistEventDate,
        artistPayout,
        artistCta
    }
}
